






































































































































































































import { Component, Vue } from "vue-property-decorator";

type PdfSection = {
  title: string;
  body: string;
};

type Capture = {
  id: string;
  title: string;
  src: string;
  body: string;
  points: string[];
};

type DemoStep = {
  title: string;
  action: string;
  concept: string;
  question: string;
  answer: string;
};

type FaqGroup = {
  title: string;
  questions: string[];
  answers: string[];
};

@Component
export default class DemoAlegaciones extends Vue {
  public pdfSections: PdfSection[] = [
    {
      title: "1. Principios de app.defichajes.es",
      body:
        "El sistema es digital por imperativo legal y garantiza objetividad " +
        "(informacion imparcial), fiabilidad (asientos protegidos) y " +
        "accesibilidad (uso sencillo e igualitario).",
    },
    {
      title: "2. Imposibilidad de modificacion unilateral",
      body:
        "Segun el Articulo 4, una vez realizado un asiento no puede ser " +
        "alterado solo por el administrador. La fiabilidad exige que cualquier " +
        "cambio cuente con autorizacion de la empresa y de la persona trabajadora.",
    },
    {
      title: "3. El modulo de alegaciones",
      body:
        "Es la herramienta para gestionar el proceso de autorizacion. Si no " +
        "hay acuerdo, la empresa registra la modificacion mientras el trabajador " +
        "refleja su discrepancia de forma expresa, cumpliendo el Articulo 4(b).",
    },
    {
      title: "4. Huella digital y trazabilidad",
      body:
        "El software genera una huella clara e indeleble que identifica que se " +
        "cambio, quien lo hizo (autoria), cuando y quien lo autorizo, asegurando " +
        "transparencia ante una auditoria.",
    },
    {
      title: "5. Garantia de libertad",
      body:
        "Los asientos son libres, personales, directos e inmediatos. El software " +
        "impide presiones tecnicas que busquen falsear la veracidad de los datos.",
    },
    {
      title: "6. Derechos de acceso",
      body:
        "Los empleados pueden consultar y obtener copia inmediata de sus " +
        "registros y modificaciones a traves de la app.",
    },
  ];

  public captures: Capture[] = [
    {
      id: "solicitudes-pendientes",
      title: "Solicitudes pendientes al iniciar sesion",
      src: "/assets/alegaciones-demo/image1.png",
      body:
        "El empleado ve solicitudes pendientes al iniciar sesion y entra " +
        "directamente a la alegacion.",
      points: [],
    },
    {
      id: "modificacion-notificada",
      title: "Notificacion y opciones de alegacion",
      src: "/assets/alegaciones-demo/image2.png",
      body:
        "La modificacion genera una notificacion; el empleado acepta o marca " +
        "discrepancias con comentario.",
      points: [],
    },
    {
      id: "acceso-alegaciones",
      title: "Acceso rapido a alegaciones",
      src: "/assets/alegaciones-demo/image3.png",
      body:
        "Acceso directo desde el menu de la aplicacion o desde la notificacion.",
      points: [
        "Aceptada: el empleado esta conforme.",
        "Pendiente: en revision, sin resolucion.",
        "Parcial: se acepta solo una parte.",
        "Discrepancia: no se acepta la alegacion.",
      ],
    },
    {
      id: "detalle-alegacion",
      title: "Detalle completo de una alegacion",
      src: "/assets/alegaciones-demo/image4.png",
      body:
        "La pantalla permite consultar, validar y gestionar una alegacion " +
        "mostrando contexto, cambios solicitados y estado del lote.",
      points: [
        "Cabecera del lote e identificadores internos.",
        "Huella digital y estado de la alegacion.",
        "Usuarios involucrados y acciones disponibles, incluido reenviar email.",
        "Comparativa de cambios con valores anterior y nuevo.",
        "Estado de respuesta y referencias para auditoria.",
      ],
    },
    {
      id: "correo-alegacion",
      title: "Correo de notificacion al empleado",
      src: "/assets/alegaciones-demo/image5.png",
      body:
        "El email comunica el cambio, identifica el fichaje y ofrece enlace " +
        "directo para revisar, aceptar o alegar.",
      points: [
        "Asunto claro y remitente oficial de la plataforma.",
        "Datos clave del fichaje y estado del lote.",
        "Aviso de seguridad si no reconoce la modificacion.",
      ],
    },
    {
      id: "historial-modificaciones",
      title: "Historial de modificaciones y discrepancias",
      src: "/assets/alegaciones-demo/image6.png",
      body:
        "Cada cambio queda reflejado con valor anterior y nuevo, fecha, usuario " +
        "y huella digital. Las discrepancias quedan registradas en el hilo del fichaje.",
      points: [],
    },
    {
      id: "registro-fichajes",
      title: "Registro de fichajes del empleado",
      src: "/assets/alegaciones-demo/image7.png",
      body:
        "Vista en tabla con cada dia fichado y etiquetas de estado basadas en " +
        "comportamiento (normal, temprano, tarde).",
      points: [
        "Entrada, salida y horas calculadas automaticamente.",
        "Transparencia y control para detectar incidencias.",
      ],
    },
  ];

  public demoSteps: DemoStep[] = [
    {
      title: "1. Introduccion: el registro diario",
      action:
        "Mostrar un fichaje de inicio/fin y pausas realizado por un empleado.",
      concept: "Los asientos deben ser inmediatos al iniciar o finalizar.",
      question: "¿Que pasa si el trabajador se olvida de fichar?",
      answer:
        "Se puede crear un asiento a posteriori, pero nace con solicitud de " +
        "alegacion/autorizacion.",
    },
    {
      title: '2. Modificacion de un asiento y la "huella"',
      action: "El administrador intenta corregir un horario por un olvido.",
      concept: "Mostrar historial; el dato original queda debajo del nuevo.",
      question: "¿Puede la empresa borrar un registro?",
      answer:
        "No. Los asientos se conservan cuatro anos y todo cambio deja rastro " +
        "indeleble.",
    },
    {
      title: "3. Flujo de alegacion (aceptacion vs discrepancia)",
      action:
        "Mostrar notificacion al empleado y el clic en Aceptar o Alegar.",
      concept:
        "La autorizacion es mutua; si hay alegacion queda en Discrepancia.",
      question: "¿Que valor tiene una modificacion si el empleado no la acepta?",
      answer:
        "La empresa puede reflejar su version, pero debe constar la discrepancia " +
        "del trabajador para garantizar la fiabilidad.",
    },
    {
      title: "4. Acceso para la inspeccion de trabajo",
      action: "Mostrar el panel de exportacion de informes.",
      concept: "El acceso debe ser remoto o presencial e inmediato.",
      question: "¿En que formato se entregan los datos?",
      answer:
        "Informes tratables, legibles y compatibles con sistemas de uso general " +
        "como Excel o PDF.",
    },
    {
      title: "5. Privacidad y protocolo",
      action: "Mostrar que los datos expuestos son los minimos necesarios.",
      concept:
        "Principios de minimizacion, idoneidad y necesidad de datos personales.",
      question: "¿Quien mas puede ver estos datos?",
      answer:
        "Solo personas autorizadas, el propio trabajador y la representacion legal " +
        "con datos anonimizados cuando sea necesario.",
    },
  ];

  public faqGroups: FaqGroup[] = [
    {
      title: "Sobre la modificacion de horarios",
      questions: [
        "¿Puede la empresa corregir un fichaje erroneo?",
        "¿Puede la empresa borrar o sustituir un registro?",
        "¿La Inspeccion puede ver el dato original?",
      ],
      answers: [
        "No se borra nada.",
        "El sistema conserva el valor original y muestra el nuevo encima.",
        "Todo queda registrado con historial y huella digital durante 4 anos.",
      ],
    },
    {
      title: "Sobre la aceptacion del trabajador",
      questions: [
        "¿Y si el trabajador no acepta la modificacion?",
        "¿Entonces la modificacion no vale?",
        "¿Nos deja vendidos ante una inspeccion?",
      ],
      answers: [
        "La empresa puede reflejar su version.",
        "El trabajador puede dejar constancia de su discrepancia expresa.",
        "La ley exige precisamente eso para que el registro siga siendo fiable y valido.",
      ],
    },
    {
      title: "Sobre la Inspeccion de Trabajo",
      questions: [
        "¿Como se entregan los datos a la Inspeccion?",
        "¿Tenemos que preparar algo manualmente?",
        "¿Tiene que ser presencial?",
      ],
      answers: [
        "El acceso es inmediato, remoto o presencial.",
        "Los informes se exportan en formatos estandar: Excel y PDF.",
        "Son legibles, tratables y compatibles con sistemas de uso general.",
      ],
    },
    {
      title: "Sobre privacidad y acceso a datos",
      questions: [
        "¿Quien puede ver los fichajes y las modificaciones?",
        "¿Puede acceder cualquiera de la empresa?",
        "¿Que pasa con la representacion legal de los trabajadores?",
      ],
      answers: [
        "Solo acceden: el propio trabajador, personas autorizadas y la representacion legal.",
        "La representacion legal ve datos anonimizados cuando procede.",
        "Se cumplen los principios de minimizacion, idoneidad y necesidad.",
      ],
    },
    {
      title: "Duda transversal: proteccion legal",
      questions: ["¿Esto es solo un reloj o me protege legalmente?"],
      answers: [
        "app.defichajes.es no es un reloj de fichar; es una plataforma de seguridad juridica.",
        "Automatiza el cumplimiento de los articulos 2, 3 y 4 del Real Decreto.",
        "Reduce el riesgo de sanciones ante una inspeccion.",
      ],
    },
  ];
}
